<div class="container">
    <div class="row">
        <div class="col-md">
            <div class="input-group flex-nowrap mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">學年</span>
                </div>
                <select class="form-select shadow-none" #Year>
                    <option value="" selected disabled>--請選擇--</option>
                    <option *ngFor="let item of Years" [value]="item">{{item}}學年</option>
                </select>
            </div>
        </div>
        <div class="col-md">
            <div class="input-group flex-nowrap mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">學期</span>
                </div>
                <select class="form-select shadow-none" #Term>
                    <option value="" selected disabled>--請選擇--</option>
                    <option *ngFor="let item of term" value="{{item.itemValue}}">{{item.itemName}}</option>
                </select>
            </div>
        </div>
        <div class="col-md">
            <div class="input-group flex-nowrap mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">製單類別</span>
                </div>
                <select #MakeDocNo class="form-select shadow-none" (change)="getMakeDocDeptList(MakeDocNo.value)">
                    <option value="" selected>--全部--</option>
                    <option value="{{item.ItemValue}}" *ngFor="let item of makeDocList">{{item.ItemName}}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-md">
            <div class="input-group flex-nowrap mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">系所</span>
                </div>
                <select #DeptNo class="form-select shadow-none">
                    <option value="" selected>--全部--</option>
                    <option value="{{item.ItemValue}}" *ngFor="let item of makeDocDeptList">{{item.ItemName}}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <div class="input-group flex-nowrap mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">狀態</span>
                </div>
                <select class="form-select shadow-none" #MakeDocStatus>
                    <option value="">--全部--</option>
                    <option value="0">製作中</option>
                    <option value="1">已送繳</option>
                    <option value="2">已製單</option>
                    <option value="3">退單</option>
                </select>
            </div>
        </div>
        <div class="col-md-3">
            <div class="input-group flex-nowrap mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">學號</span>
                </div>
                <input type="text" class="form-control shadow-none" #StdNo>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <button class="search-btn float-start me-3"
                (click)="getTFSMakeDocSingleList(Year.value, Term.value, DeptNo.value, MakeDocNo.value, StdNo.value, MakeDocStatus.value)">查詢</button>
            <button class="other-Button-gray float-start me-3" (click)="getTFSMakeDocSingleMake()">製作</button>
            <button class="other-Button-gray float-start me-3" (click)="getTFSMakeDocSingleSend()">繳交出納</button>
            <button class="save-btn-gray float-end" (click)="getTFSMakeDocSingleSave()">儲存</button>
        </div>
    </div>
</div>

<div class="container-fluid mt-3">
    <div class="row">
        <div class="col-md">
            <table class="table table-hover table-striped text-center">
                <thead class="thead-dark-red">
                    <tr>
                        <th><input type="checkbox" (click)="setDatakey('all', '', $event.target)"
                                class="pointer">&ensp;全選</th>
                        <th>班級</th>
                        <th>學號</th>
                        <th>姓名</th>
                        <th>身分別</th>
                        <th>狀態</th>
                    </tr>
                </thead>
                <tbody>
                    <tr [ngClass]="{'':item.Selected == false, 'row-selected-bg':item.Selected == true}"
                        *ngFor="let i = index; let item of tFSMakeDocSingleList" class="pointer"
                        (click)="getTFSMakeDocSingleDetail(i, item.DataKey)">
                        <td><input type="checkbox" [checked]="item.checked"
                                (click)="setDatakey('', item.DataKey, $event.target)" class="pointer"></td>
                        <td>{{item.ClassName}}</td>
                        <td>{{item.StdNo}}</td>
                        <td>{{item.StdName}}</td>
                        <td>{{item.EntryName}}</td>
                        <td>{{item.StatusName}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md">
            <table class="table table-hover text-center">
                <thead class="thead-dark-red">
                    <tr>
                        <th></th>
                        <th>收費代碼</th>
                        <th>收費項目</th>
                        <th>預設金額</th>
                        <th>應繳金額</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let i = index; let item of tFSMakeDocSingleDetail">
                        <td>{{i+1}}</td>
                        <td>{{item.FeeNo}}</td>
                        <td style="width: 120px;">{{item.FeeName}}</td>
                        <td>{{item.DefaultMoney}}</td>
                        <td><input type="text" style="width: 80px;" class="form-control form-control-input"
                                [(ngModel)]="item.MustMoney" [disabled]="item.Edit != 'Y'"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>